import { FC } from 'react'

const Circle: FC<React.SVGProps<SVGSVGElement>> = ({
  className,
  height,
  stroke,
  width,
  ...rest
}) => {
  return (
    <svg
      className={className}
      width={width || '24'}
      height={height || '24'}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <circle cx='12' cy='12' r='9.5' stroke={stroke ?? '#1D1D1F'} />
    </svg>
  )
}

export default Circle
